<template>
  <div id="otAbout">
    <div id="otTopInput">
      <el-input
        placeholder="请输入组织名称查询"
        v-model="filterText"
        class="input-with-select"
        size="small"
        clearable>
        <el-button slot="append" icon="el-icon-search" @click="treeFilter"></el-button>
      </el-input>
    </div>
    <div id="otTreeDiv">
      <el-tree
      v-loading="loading"
      element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading"
        class="filter-tree"
        :data="enumData"
        :props="defaultProps"
        node-key="id"
        highlight-current
        :expand-on-click-node="false"
        @node-click="treeNodeClick"
        :filter-node-method="filterNode"
        :default-expanded-keys="defaultExpandedKeys"
        :default-checked-keys="defaultCheckedKeys"
        show-checkbox
        :check-strictly="true"
        @check-change="handleCheckChange"
        ref="tree">
      </el-tree>
    </div>
  </div>
</template>

<script>
  import {getAdmOrgTreeChecked} from '../api/admOrg'
  export default {
    data () {
      return {
        filterText: '',
        enumData: [],
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        parentId: '-1',
        nodeId: '',
        chooseTreeNode: {},
        defaultExpandedKeys: [],
        checkedData: [],
        defaultCheckedKeys: [],
        loading: false,
      }
    },
    props: {
      parentMsg: String,
      filter:{
        type:Boolean
      }
    },
    watch: {
      parentMsg (newVal, oldVal) {
        this.getTemplateTree('refresh')
      }
    },
    mounted: function () {
      this.getTemplateTree('new')
    },
    methods: {
      treeFilter () {
        this.$refs.tree.filter(this.filterText)
      },
      getTemplateTree (data) {
        // this.loading=true;
        this.defaultCheckedKeys = [];
        getAdmOrgTreeChecked('?roleId='+this.parentMsg+"&async=0").then(response => {
          let mainTree = {id:'-1', label:'安责险信息管理综合服务平台'}
          if (response.length <= 0) {
            this.enumData = [mainTree];
          } else {
            response.some((val)=>{
              if(val.checked){
                this.defaultCheckedKeys.push(val.id);
              }
              if(val.children && val.children.length>0 ){
                this.dealTree(val.children);
              }
            })
            mainTree.children = response
            let temp = [mainTree]

            // 展开至第一级
              this.defaultExpandedKeys = [temp[0].id]
              if (temp[0].children !== null && temp[0].children.length > 0) {
                // 展开至第二级
                for (var i = 0; i < temp[0].children.length; i++) {
                  this.defaultExpandedKeys.push(temp[0].children[i].id)
                }
            }
            this.enumData = temp
            // 过滤显示选中节点
            if (this.filter) {
              this.$nextTick(() => {
                this.$refs.tree.filter(1)
              })
            }
          }
          // this.loading=false;
        }).catch(error => {
          // this.loading=false;
          console.log('error:' + error.toString())
        })
      },
      dealTree(data){
        data.map((val)=>{
          if(val.checked){
            this.defaultCheckedKeys.push(val.id);
          }
          if(val.children && val.children.length>0 ){
            this.dealTree(val.children);
          }
        });
        // return data;
      },
      handleCheckChange(data, checked, indeterminate) {
        // console.log(data, checked, indeterminate);
        // if(checked){
        //   this.checkedData.push(data);
        // }else{
        //   if(this.checkedData && this.checkedData.length>0){
        //     this.checkedData.some(())
        //   }
        // }
        if (this.filter) {
          this.$refs.tree.filter(1)
        }
        console.log(this.$refs.tree.getCheckedNodes());
        this.$emit('checkedTree', this.$refs.tree.getCheckedNodes(),this.filter);
      },
      treeNodeClick (node) {
        this.chooseTreeNode = node
        this.$emit('treeInfo', { 'listenParentId': node.id, 'listenParentName': node.label })
      },
      filterNode (value, data,node) {
        if (this.filter && !this.filterText) {
          return node.checked || node.indeterminate
        } else  {
          if (!value) return true;
          return data.label.indexOf(value) !== -1;
        }
      },
      selectOrg(id, name) {
        this.filterText = name
        this.$refs.tree.filter(this.filterText)
        this.$nextTick(()=> {
          this.$refs.tree.setCurrentKey(id)
        })
      }
    },
  }
</script>

<style scoped>
  #otAbout {
    height: calc(100% - 30px);
    display: flex;
    flex-direction: column;
  }

  #otTreeDiv {
    width: 100%;
    height: 100%;
    /*height: -webkit-calc(100% - 32px);*/
    /*height: calc(100% - 32px);*/
    overflow: hidden;
    overflow-y: auto;
  }
  .filter-tree {
      width: 100%;
      height: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/OrgTreeCheck.vue